var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block",style:([_vm.width && { width: `${_vm.width}px` }])},[_vm._v(" "+_vm._s(_vm.displayNumber)),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }